import React, {useState,useEffect} from 'react'
import axios from 'axios'
import ImgMediaCard from './ImgMediaCard'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
const App = () => {
  
  const [posts,setPosts]=useState([])
  const [isLoading,setIsLoading]=useState(true)
  const classes = useStyles();
  useEffect(()=>{
 //fetching Data using Axios

    axios.get('https://jsonplaceholder.typicode.com/photos')
      .then(res=>{console.log(res) 
      setPosts(res.data)
      setIsLoading(false)
      })
      .catch(err=>console.log(err))
},[])
  return (
    <div style={{"textAlign":"center"}}>
      <Grid container spacing={3}>
      {isLoading ? "Fetching Data...." : posts.map(post=>
      <Grid item xs={12} sm={6} lg={3}>
      <Paper className={classes.paper}><ImgMediaCard key={post.id} id={post.id} url={post.url} title={post.title} /></Paper>
    </Grid>
  )}
      </Grid>
    </div>
  )
}
export default App
